/**
 * Round close/dismiss button — filled circle with an × icon.
 * Works on any surface in both light and dark themes.
 *
 * Props:
 *   onClick    — click handler
 *   ariaLabel  — accessible name (default: "Close")
 *   disabled   — disables interaction
 *   className  — extra classes on the root button
 */
import { FiX } from 'react-icons/fi';

export default function CloseButton({
  onClick,
  ariaLabel = 'Close',
  disabled = false,
  className = '',
  ...props
}) {
  const classes = ['close-btn', className].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      {...props}
    >
      <FiX size={16} aria-hidden="true" />
    </button>
  );
}
